module.exports = __webpack_public_path__ + "static/img/03best.e81894b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/dark/sport/07sportIndex/03best.png
// module id = Ku1A
// module chunks = 0